var render = function render(){var _vm=this,_c=_vm._self._c;return (!_vm.isTribe)?_c('div',{staticClass:"l-login-span",on:{"click":_vm.onLogout}},[_c('img',{staticClass:"l-login-icon",attrs:{"src":require("../images/tuichu.png")}}),_vm._v(" 退出登录 ")]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }